import { SmallHeadline } from '@minted/fancyclothes';
import React, { memo } from 'react';
import isEqual from 'lodash/isEqual';
import { ThemedRichText } from './ThemedRichText';
import { BLANK_SLATE_DOCUMENT } from '../../../core/constants';
import { SectionComponentProps } from '../../types';
import { TextDetails } from '../../../resources/modelTypes';

const DisplayTextSection = ({
  section,
}: SectionComponentProps) => {
  const details = section.sectionDetails as TextDetails;

  return (
    <>
      {
        Boolean(details.title) && (
          <SmallHeadline>
            {details.title}
          </SmallHeadline>
        )
      }
      {
        details.content && !isEqual(details.content, BLANK_SLATE_DOCUMENT) && (
          <ThemedRichText content={details.content} />
        )
      }
    </>
  );
};

const MemoizedDisplayImageAndText = memo(DisplayTextSection);

export { MemoizedDisplayImageAndText as DisplayTextSection };
